<strong class="screen_out">shortcut link list</strong>
<ul class="list_shortcut">
  <li>
    <a class="link_shortcut" (click)="onClickQuickCommand($event, 'hs')"># HS Code Finder</a>
  </li>
  <li>
    <a class="link_shortcut" (click)="onClickQuickCommand($event, 'un')"># Unipass</a>
  </li>
</ul>
